import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnChanges, OnInit,  SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import * as D3 from 'd3'

@Component({
  selector: 'k-ng-gallery',
 templateUrl:'./ng-gallery.component.html',
 styleUrls: ['./ng-gallery.component.less']
})
export class NgGalleryComponent implements OnInit {

  // @ViewChild('wrapper',{static:true}) wrapper:ElementRef
  // @ViewChild('canvas',{static:true}) canvas:ElementRef

  // @Input() url
  // @Input() annotationData

  @Input() list  
  @Input() showAnimation = true;
  @Input() showSidebar = true;
  @Input() showToolbar = true;

  @Input() startIndex
  @Input() endIndex

  @Input() toggleSidebarTemplate:TemplateRef<any>|null = null

  @ViewChild('gallery',{static:true}) gallery

  // data = {
  //   scale:0,
  //   canvasSize:{
  //     width:0,
  //     height:0
  //   },
  //   imageSize:{
  //     width:0,
  //     height:0
  //   },
  //   top:0,
  //   left:0,
  //   offset:0
  // }
  
  // content:SVGSVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg')  ;

  activeIndex:number = 0;

 

  constructor(
    // private element:ElementRef,
    // private http:HttpClient
  ) { }

  // ngOnChanges(change:SimpleChanges){
     
  //   if(change.url){
  //     this.makeImage()
  //   }
  // }
  ngOnInit(): void {

    // this.content.setAttribute('id', 'cvat_canvas_content');
    // this.wrapper.nativeElement.appendChild(this.content)

  }

  rerender(){
    this.gallery.update()
  }

  changeActiveIndex(gonext:boolean){
    if(gonext){
      this.activeIndex+=1;
    }else{
      this.activeIndex-=1;
    }
    /////////////////////////////////////////////
    if(this.activeIndex>this.endIndex){
      this.activeIndex = this.startIndex
    }else if(this.activeIndex<this.startIndex){
      this.activeIndex = this.endIndex
    }

  }

  // makeImage(){
  //   let _this = this;

  //   let image = new Image();
  //   image.src = this.url;
  //   let canvas:HTMLCanvasElement = this.canvas.nativeElement
     
  //   let ctx = canvas.getContext('2d');
  //   image.onload = function(res){
  //     canvas.height = image.height;
  //     canvas.width = image.width;
 
  //     _this.data.imageSize.width = image.width;
  //     _this.data.imageSize.height = image.height;

      
  //     _this.notify(updateReasons.IMAGE_CHANGED)

       
  //     ctx.drawImage(image,0,0);

  //     // _this.moveCanvas()
  //     _this.fitCanvas();
 
  //     // _this.transformCanvas();
  //     // _this.fitCanvas();
      
  //     _this.setupObjects();
  //   };


  // }
  // moveCanvas(){
  //   this.canvas.nativeElement.style.top = this.data.top+'px';
  //   this.canvas.nativeElement.style.left = this.data.left+'px';

  //   this.content.style.top = `${this.data.top - this.data.offset}px`;
  //   this.content.style.left = `${this.data.left - this.data.offset}px`
  // }
  // fitCanvas(){
  //   let height = this.wrapper.nativeElement.clientHeight;
  //   let width = this.wrapper.nativeElement.clientWidth;

  //   this.data.offset = Math.floor(
  //     Math.max(
  //       height/0.1,
  //       width/0.1
  //     )
  //   );

  //   this.data.canvasSize.height = height;
  //   this.data.canvasSize.width = width;


      
  //   this.notify(updateReasons.IMAGE_FITTED)
  //   this.notify(updateReasons.FITTED_CANVAS)
  // }
  // resizeCanvas(){
  //   this.canvas.nativeElement.style.width = this.data.imageSize.width+'px';
  //   this.canvas.nativeElement.style.height = this.data.imageSize.height+'px';
     
  //   this.content.style.width = `${this.data.imageSize.width + this.data.offset*2}px`;
  //   this.content.style.height = `${this.data.imageSize.height + this.data.offset*2}px`
     
  // }
  // transformCanvas(){
  //   this.canvas.nativeElement.style.transform = `scale(${this.data.scale})`;
  //   this.content.style.transform = `scale(${this.data.scale})`
  // }

  // fit(){
  //   let scale  = Math.min(
  //     this.data.canvasSize.width / this.data.imageSize.width,
  //     this.data.canvasSize.height / this.data.imageSize.height,
  //   );
    
  //   this.data.scale = Math.min(
  //     Math.max(scale, 0.1),
  //     10,
  //   );
    
  //   this.data.top = (this.data.canvasSize.height / 2 - this.data.imageSize.height / 2);
  //   this.data.left = (this.data.canvasSize.width / 2 - this.data.imageSize.width / 2);
    
  //   this.notify(updateReasons.IMAGE_FITTED)
  // }
  // ////////////////////////////

  // setupObjects(){
  //   let offset = this.data.offset;
  //   let points =  this.annotationData.points.map(res=>res+offset)
  //   const [xtl, ytl, xbr, ybr] = points;

  //   let rect = D3.select(this.content)
  //   .append('rect')
  //   // .attr('clientid',state.clientID)
  //   //  .attr('id',`kvat_canvas_shape_${state.clientID}`)
  //   //  .attr('fill',state.color)
  //    .attr('fill-opacity',0.03)
  //    .attr('stroke','red')
  //   //  .attr('stroke-width',consts.BASE_STROKE_WIDTH / this.geometry.scale)
  //    .attr('color-rendering','optimizeQuality')
  //    .attr('shape-rendering','geometricprecision')
  //   //  .attr('data-z-order',state.zOrder)
  //    .attr('width',xbr-xtl)
  //    .attr('height',ybr-ytl)
  //    .attr('x',xtl)
  //    .attr('y',ytl)
  //    .classed('kvat_canvas_shape',true)

  // }

  // notify(reason:updateReasons){
  //   if(reason==updateReasons.IMAGE_CHANGED){
  //     this.fit()
  //     this.moveCanvas();
  //     this.resizeCanvas();

  //     this.transformCanvas();
  //   }else if (reason == updateReasons.FITTED_CANVAS){
  //     this.fit()
  //     this.moveCanvas();
  //     this.resizeCanvas();
  //   }else if ([updateReasons.IMAGE_ZOOMED,updateReasons.IMAGE_FITTED].includes(reason)){
  //     this.moveCanvas();
  //     this.transformCanvas();
  //   }
  // }
}


// enum updateReasons {
//   IMAGE_CHANGED = "image_changed",
//   IMAGE_ZOOMED = 'image_zoomed',
//   IMAGE_FITTED = 'image_fitted',
//   IMAGE_MOVED = 'image_moved',
//   FITTED_CANVAS = 'fitted_canvas',
//   // OBJECTS_UPDATED = 'objects_updated',

// }